const colors = {
    primary: "#1E1E1C",
    secondary: "#496C99",
    white: "#FFFFFF",
    green: "#2FEA52",
    gray4: '#BDBDBD',
    gray8: '#E5E5E5',
    input: '#F0F9FD',
    separator: '#DEDEDE',
    textSecondary: '#9495A9',
    textPrimary: '#323352',
    brand: {
        50: '#e8f4ec',
        100: '#cce2d6',
        200: '#99c5ad',
        300: '#66a884',
        400: '#338a5b',
        500: '#0A4725', // główny zielony
        600: '#083b1f',
        700: '#062f19',
        800: '#041f12',
        900: '#02130b',
    }
}

export default colors;
